import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InvestmentService {

  constructor(private httpService: HttpService) { }


    addInvestmentData(object) {
        console.log("object", object);
        // return this.http.post(environment.pssUrl + 'Investment/ecsEntry', object) // When u r posting any data(i.e. Save or update do not use this type of method call)
        //         .map(res => res.json());
        var request = {
            URL: "investment/investmentEntry",
            DATA: object
        }
        return this.httpService.post(request);


    }

    getRegisterDirector(object) {
        var registerList = {
                URL: "investment/getInvestmentDetails/5cee33d225242e023acfb2d4",
                DATA: object
            }
        return this.httpService.post(registerList);
    }

    getInvestmentData(investmentId){
        var editList = {
            URL: "investment/getInvestmentDetails/" +investmentId,
    }
    return this.httpService.get(editList);
    }

    removeinvestmentdetails(_id){
        var request = {
            URL: "investment/deletadetails/" + _id
        }
        return this.httpService.get(request);
    }
    updateinvestment(_id) {
        var editlist = {
            URL: "investment/update/" + _id,
        }
        return this.httpService.get(editlist);
    }

    updateInvestmentAccountParticulars(object, id) {
        var request = {
            URL: "investment/updateInvestmentAccountParticular/" +id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    generateInvestmentDocument(object) {
        var request = {
            URL: "investment/generateInvestmentDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadInvestmentFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "investment/downloadDocument/" + id + "/" + type + "/" + token;
    }

    downloadInvestmentPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "investment/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}
